import React, { useEffect, Suspense, lazy, Component } from 'react';
import { initPixel } from './lib/fpixel';
import { Hero } from './components/Hero';
/* Below-the-fold sections are lazy-loaded so the first screen paints fast.
   Components use named exports, so we map them to a default for lazy. */
const SocialMetrics = lazy(() => import('./components/SocialMetrics').then(m => ({
  default: m.SocialMetrics
})));
const OpeningTestimonials = lazy(() => import('./components/OpeningTestimonials').then(m => ({
  default: m.OpeningTestimonials
})));
const PainAgitation = lazy(() => import('./components/PainAgitation').then(m => ({
  default: m.PainAgitation
})));
const ProductPresentation = lazy(() => import('./components/ProductPresentation').then(m => ({
  default: m.ProductPresentation
})));
const Tomos = lazy(() => import('./components/Tomos').then(m => ({
  default: m.Tomos
})));
const Bonos = lazy(() => import('./components/Bonos').then(m => ({
  default: m.Bonos
})));
const UrgencySection = lazy(() => import('./components/UrgencySection').then(m => ({
  default: m.UrgencySection
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const EliteComparison = lazy(() => import('./components/EliteComparison').then(m => ({
  default: m.EliteComparison
})));
const EliteEbooks = lazy(() => import('./components/EliteEbooks').then(m => ({
  default: m.EliteEbooks
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const ExtendedTestimonials = lazy(() => import('./components/ExtendedTestimonials').then(m => ({
  default: m.ExtendedTestimonials
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalComparison = lazy(() => import('./components/FinalComparison').then(m => ({
  default: m.FinalComparison
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Suspense fallback={null} data-id="element-2">
        <SocialMetrics data-id="element-3" />
        <OpeningTestimonials data-id="element-4" />
        <PainAgitation data-id="element-5" />
        <ProductPresentation data-id="element-6" />
        <Tomos data-id="element-7" />
        <Bonos data-id="element-8" />
        <UrgencySection data-id="element-9" />
        <Pricing data-id="element-10" />
        <EliteComparison data-id="element-11" />
        <EliteEbooks data-id="element-12" />
        <Guarantee data-id="element-13" />
        <ExtendedTestimonials data-id="element-14" />
        <FAQ data-id="element-15" />
        <FinalComparison data-id="element-16" />
        <FinalCTA data-id="element-17" />
        <Footer data-id="element-18" />
        <PurchasePopup data-id="element-19" />
      </Suspense>
    </div>;
}